export default "__VITE_ASSET__pGDJuMyE__"